var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-card-wrap',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"hasSlot":""}},[_c('template',{slot:"title"},[_vm._v("概况")]),_c('summary-list',{attrs:{"list":_vm.list1,"span":6}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }